export default function MoreIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10.0003 18.3337C14.6028 18.3337 18.3337 14.6028 18.3337 10.0003C18.3337 5.39783 14.6028 1.66699 10.0003 1.66699C5.39783 1.66699 1.66699 5.39783 1.66699 10.0003C1.66699 14.6028 5.39783 18.3337 10.0003 18.3337Z"
                stroke="#576A81"
                stroke-width="1.2"
                stroke-linejoin="round"
            />
            <path
                d="M5.83398 11.25C6.52434 11.25 7.08398 10.6904 7.08398 10C7.08398 9.30964 6.52434 8.75 5.83398 8.75C5.14363 8.75 4.58398 9.30964 4.58398 10C4.58398 10.6904 5.14363 11.25 5.83398 11.25Z"
                fill="#576A81"
            />
            <path
                d="M10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25Z"
                fill="#576A81"
            />
            <path
                d="M14.167 11.25C14.8573 11.25 15.417 10.6904 15.417 10C15.417 9.30964 14.8573 8.75 14.167 8.75C13.4766 8.75 12.917 9.30964 12.917 10C12.917 10.6904 13.4766 11.25 14.167 11.25Z"
                fill="#576A81"
            />
        </svg>
    );
}
